<template>
  <section>
    <div class="grid-x card-grid grid-padding-x">
      <widget-failed-oppgjor v-if="hasAccess('accounting')"/>
      <widget-oppgaver v-bind:brukerList="brukerList"/>
      <widget-uferdige-kontrakt v-bind:brukerList="brukerList"/>
      <widget-uferdige-objekt v-bind:brukerList="brukerList"/>
      <widget-mine-tall v-bind:brukerList="brukerList"/>
    </div>
  </section>
</template>

<script>
import WidgetUferdigeKontrakt from './WidgetUferdigeKontrakt'
import WidgetUferdigeObjekt from './WidgetUferdigeObjekt'
import WidgetOppgaver from './WidgetOppgaver'
import WidgetFailedOppgjor from './WidgetFailedOppgjor'
import WidgetMineTall from './WidgetMineTall'

export default {
  name: 'PageOverview',
  components: {
    WidgetUferdigeKontrakt,
    WidgetUferdigeObjekt,
    WidgetOppgaver,
    WidgetFailedOppgjor,
    WidgetMineTall
  },
  props: {
    brukerList: {
      type: Array,
      required: false,
      default () {
        return []
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Dashboard/PageOverview.vue